// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__aGRG6","toolbar":"Header_toolbar__2yMqK","logo":"Header_logo__2UxYO","link":"Header_link___oXom"};